app.directive('inputProduitCustomFieldValue', ['contratService', function (contratService) {
    return {
        restrict: 'E',
        templateUrl: "/templates/partials/directives/forms/produit/produit_fields/input-produit-field-value.html",
        scope: {
            produitField: '='
        },
        link: function (scope, element, attrs) {
    
            scope.baseContratUrl = contratService.urlContrat('');

            /*
                types : 
                - string
                - text
                - list (multiple / simple)
                - number
                - boolean
                - datetime : @TODO
                - date : @TODO
                - image
                - file
            */

        }
    };
}]);
